export const BlockedMode = {
  ALL_BLOCKED: 'ALL_UNITS',
  ALL_ACCOMMODATIONS_BLOCKED: 'ALL_ACCOMMODATIONS',
  ALL_RENTAL_UNITS_BLOCKED: 'ALL_RENTAL_UNITS_BLOCKED',
  SELECTED_UNITS: 'SELECTED_UNITS'
};
Object.freeze(BlockedMode);
